/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect, useState } from "react";

import _ from "lodash";
import range from "lodash/range";
import Link from "next/link";
import { useRouter } from "next/router";
import styled, { css, DefaultTheme } from "styled-components";

import CellEntityAvatar from "../CellEntityAvatar";
import TransactionDetailsModal from "../TransactionDetailsModal";
import ApproveCancelButton from "./components/ApproveCancelButton";
import BeneficiaryAcceptDeclineButton from "./components/BeneficiaryAcceptDeclineButton";
import SVGEdit from "./components/SVGEdit";
import SVGInfo from "./components/SVGInfo";
import TransactionRowCellStatus from "./components/TransactionRowCellStatus";

import { Button, ButtonLink } from "~/components/Button";
import * as Grid from "~/components/Grid";
import Skeleton from "~/components/Skeleton";
import * as Table from "~/components/Table";
import { Text } from "~/components/Text";
import { TransactionStatus } from "~/endpoints/transactions/types";
import { useTfSimpleVaspInfo } from "~/endpoints/trustFramework";
import { useSessionWrap } from "~/hooks/use-session";
import { TransactionWrap } from "~/hooks/use-transaction";
import AcceptIncomingTxModal from "~/templates/transactions/components/AcceptIncomingTxModal";
import ApproveOutgoingTxModal from "~/templates/transactions/components/ApproveOutgoingTxModal";
import CancelOutgoingTxModal from "~/templates/transactions/components/CancelOutgoingTxModal";
import DeclineIncomingTxModal from "~/templates/transactions/components/DeclineIncomingTxModal";
import { TRANSACTIONS_TABLE_HEADERS } from "~/templates/transactions/components/TransactionTable";
import { TRANSACTION_TYPES } from "~/templates/transactions/types";
import { formatterDateTime } from "~/utils/formatterDateTime";
import { removeQueryParam } from "~/utils/url";

//TODO: All the CellEntity stuff should be in its own component [Lluis Suros]
export const CellEntityContainer = styled(Button)`
  display: flex;
  align-items: center;
  border: solid 1px ${(props) => props.theme.colors.lightGray};
  height: calc(0.65rem * 4.5);
  padding-left: 0.5em;
  padding-right: 0.5em;
`;
CellEntityContainer.defaultProps = {
  fullwidth: true,
  align: "left",
};
export const CellEntityTitle = styled(Text)`
  display: block;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 145px;
  color: rgb(54, 53, 56);
  font-size: 0.9rem !important;
`;
CellEntityTitle.defaultProps = {
  weight: "bolder",
};
export function CellEntity({ title, logo, children, ...props }: React.ComponentProps<typeof CellEntityContainer>) {
  return (
    <CellEntityContainer {...props}>
      <CellEntityAvatar src={logo} seed={title} />
      <CellEntityTitle title={title} className="localize-ignore">
        {children}
      </CellEntityTitle>
    </CellEntityContainer>
  );
}
export const ArrowOutLong = styled((props) => (
  <svg width="141" height="16" viewBox="0 0 141 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M140.707 8.70711C141.098 8.31658 141.098 7.68342 140.707 7.29289L134.343 0.928932C133.953 0.538408 133.319 0.538408 132.929 0.928932C132.538 1.31946 132.538 1.95262 132.929 2.34315L138.586 8L132.929 13.6569C132.538 14.0474 132.538 14.6805 132.929 15.0711C133.319 15.4616 133.953 15.4616 134.343 15.0711L140.707 8.70711ZM0 9L140 9V7L0 7L0 9Z"
      fill="#3DC729"
    />
  </svg>
))``;
export const ArrowInLong = styled((props) => (
  <svg width="141" height="16" viewBox="0 0 141 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.292893 7.29288C-0.097631 7.68341 -0.0976311 8.31657 0.292893 8.70709L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6568L2.41421 7.99999L8.07107 2.34313C8.46159 1.95261 8.46159 1.31944 8.07107 0.928921C7.68054 0.538396 7.04738 0.538396 6.65685 0.92892L0.292893 7.29288ZM141 7L1 6.99999L1 8.99999L141 9L141 7Z"
      fill="#8E61B0"
    />
  </svg>
))``;
export const ArrowOut = styled((props) => (
  <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.7071 8.70711C19.0976 8.31658 19.0976 7.68342 18.7071 7.29289L12.3431 0.928932C11.9526 0.538408 11.3195 0.538408 10.9289 0.928932C10.5384 1.31946 10.5384 1.95262 10.9289 2.34315L16.5858 8L10.9289 13.6569C10.5384 14.0474 10.5384 14.6805 10.9289 15.0711C11.3195 15.4616 11.9526 15.4616 12.3431 15.0711L18.7071 8.70711ZM0 9L18 9V7L0 7L0 9Z"
      fill="#3DC729"
    />
  </svg>
))``;
export const ArrowIn = styled((props) => (
  <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM19 7L1 7V9L19 9V7Z"
      fill="#8E61B0"
    />
  </svg>
))``;
export const ArrowInBoth = styled((props) => (
  <svg width="24" height="20" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33166 0.930826L10.706 7.28443C11.0971 7.67431 11.0982 8.30748 10.7083 8.69864L4.35466 15.0729C3.96477 15.4641 3.33161 15.4651 2.94045 15.0752C2.54929 14.6854 2.54826 14.0522 2.93815 13.661L7.58742 8.99661L1.00164 9.00732L0.99839 7.00732L7.58417 6.99661L2.91974 2.34734C2.52858 1.95745 2.52755 1.32429 2.91744 0.933126C3.30733 0.541967 3.9405 0.540937 4.33166 0.930826Z"
      fill="#BCBCBC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7363 15.0976L13.301 8.80587C12.9061 8.41977 12.899 7.78665 13.2851 7.39174L19.5768 0.95641C19.9629 0.561506 20.5961 0.554364 20.991 0.940459C21.3859 1.32655 21.393 1.95968 21.0069 2.35458L16.4029 7.06366L22.9882 6.98938L23.0108 8.98926L16.4254 9.06354L21.1345 13.6676C21.5294 14.0537 21.5366 14.6868 21.1505 15.0817C20.7644 15.4766 20.1312 15.4837 19.7363 15.0976Z"
      fill="#BCBCBC"
    />
  </svg>
))``;
const ARROW_IN_ROW = css`
  position: absolute;
  top: calc(50% - 8px);
  right: -12px;
  z-index: 10;

  height: 16px;
  width: 16px;
`;
const ArrowOutRow = styled(ArrowOut)`
  ${ARROW_IN_ROW}
`;
const ArrowInRow = styled(ArrowIn)`
  ${ARROW_IN_ROW}
`;
const ARROW_IN_ROW_BOTH = css`
  position: absolute;
  top: calc(50% - 10px);
  z-index: 10;
  right: -13px;
  height: 20px;
  width: 25px;
`;
const ArrowInBothRow = styled(ArrowInBoth)`
  ${ARROW_IN_ROW_BOTH}
`;

const TableTDClickable = styled(Table.TD)`
  cursor: pointer;
`;
const TableTDColored = styled(Table.TD)<{
  color?: keyof DefaultTheme["colors"];
}>`
  &&& {
    border-right: 6px solid ${(props) => (props.color ? props.theme.colors[props.color] : "transparent")};
  }
`;
const AssetText = styled.div`
  font-weight: bold;
`;
const FiatText = styled.div`
  color: #7e7e7e;
`;

const TransactionRowCellSkeleton = React.memo((props: React.ComponentPropsWithoutRef<typeof Table.TD>) => {
  return (
    <Table.TD {...props}>
      <Table.Cell>
        <Text>
          <Skeleton count={2} />
        </Text>
      </Table.Cell>
    </Table.TD>
  );
});
TransactionRowCellSkeleton.displayName = "TransactionRowCellSkeleton";

export type TransactionRowProps = {
  transaction?: TransactionWrap | null;
  $loading?: boolean;
  onClickApprove?: (id: string) => void;
  onClickCancel?: (id: string) => void;
  refreshTxListCb: () => void;
  children?: React.ReactNode;
  hideActions: boolean;
  requestTrackingForMissingData?: boolean;
};

export default function TransactionRow({
  transaction,
  $loading,
  refreshTxListCb,
  hideActions,
  requestTrackingForMissingData = false,
}: TransactionRowProps) {
  const [{ vasp }] = useSessionWrap();
  const router = useRouter();

  const [counterPartyVaspDid, setCounterPartyVaspDid] = useState<string | undefined>(undefined);
  const { data: counterVaspSimpleInfoData } = useTfSimpleVaspInfo(
    counterPartyVaspDid,
    ["did", "name", "logo"],
    undefined,
    false,
    {
      dedupingInterval: 3600000, // Refetch once per hour...no reason to keep refetching these logos over and over
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const [showTransactionDetailsModal, setShowTransactionDetailsModal] = useState<boolean>(false);
  const [showDeclineIncomingTxModal, setShowDeclineIncomingTxModal] = useState<boolean>(false);
  const [showAcceptIncomingTxModal, setShowAcceptIncomingTxModal] = useState<boolean>(false);
  const [showApproveOutgoingTxModal, setShowApproveOutgoingTxModal] = useState<boolean>(false);
  const [showCancelOutgoingTxModal, setShowCancelOutgoingTxModal] = useState<boolean>(false);
  const [isOutgoingPage, setIsOutgoingPage] = useState<boolean>(false);

  const _addDetailsQueryParam = (transactionId: string) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, transaction_id_details: transactionId },
    });
  };

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const { query } = router;
    const pageType = query.pageType;
    setIsOutgoingPage(!!pageType?.includes("outgoing"));

    const transactionDetailsId = query.transaction_id_details;
    if (transaction && transactionDetailsId && transactionDetailsId === transaction.id) {
      setShowTransactionDetailsModal(true);
    } else {
      setShowTransactionDetailsModal(false);
    }
  }, [router.isReady, router, transaction]);

  const handleDetailsClose = () => {
    removeQueryParam("transaction_id_details", router);
  };

  if (!transaction || !vasp) {
    return (
      <Table.TR>
        {range(TRANSACTIONS_TABLE_HEADERS.length).map((i) => (
          <TransactionRowCellSkeleton key={i} />
        ))}
      </Table.TR>
    );
  }

  const [, counterVASPDid, direction] = transaction.direction(vasp);
  if (counterVASPDid && counterVASPDid !== counterPartyVaspDid) {
    //fetch vasp details
    setCounterPartyVaspDid(counterVASPDid || undefined);
  }

  const logo = counterVaspSimpleInfoData?.logo || "/assets/vasp-fallback.png";
  const isOutgoing = direction === "outgoing";
  const isIncoming = direction === "incoming";
  const isInternal = direction === "internal";
  const isInternalOutgoing = isInternal && isOutgoingPage;
  const isInternalIncoming = isInternal && !isOutgoingPage;

  const originatorDid = transaction.originatorDid;
  const beneficiaryDid = transaction.beneficiaryDid;
  const fiatAmount = isOutgoing ? transaction.amountInLocalCurrency : transaction.beneficiaryAmountInLocalCurrency;

  let color: keyof DefaultTheme["colors"] | undefined;
  if (transaction.isAcknowledged || transaction.isSaved || transaction.isAccepted) {
    color = "success";
  } else if (transaction.isCancelled || transaction.isRejected || transaction.isDeclined) {
    color = "danger";
  }

  const TEXT_SIZE = { style: { fontSize: "0.9rem" } };

  const showOriginatorApproveCancelButtons =
    (isOutgoing || isInternalOutgoing) &&
    (transaction.isMissingBeneficiaryData ||
      transaction.isNew ||
      transaction.isWaiting ||
      transaction.isSent ||
      transaction.isIncomplete);

  const showBeneficiaryAcceptDeclineButtons =
    (isIncoming || isInternalIncoming) &&
    (transaction.isAcknowledged || transaction.isSent || transaction.isIncomplete);

  const showDetailsInfoButton = transaction !== null;
  const showEditButton =
    ((isOutgoing || isInternalOutgoing) &&
      [TransactionStatus.MISSING_BENEFICIARY_DATA, TransactionStatus.INCOMPLETE].includes(transaction.status)) ||
    ((isIncoming || isInternalIncoming) && transaction.status === TransactionStatus.INCOMPLETE);

  const formattedCreatedAtDate = formatterDateTime.format(transaction.createdAt);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(transaction.createdAt);
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  }).format(transaction.createdAt);

  return (
    <Table.TR>
      {showDeclineIncomingTxModal && (
        <DeclineIncomingTxModal
          transaction={transaction}
          onClose={() => {
            setShowDeclineIncomingTxModal(false);
            refreshTxListCb();
          }}
        />
      )}
      {showAcceptIncomingTxModal && (
        <AcceptIncomingTxModal
          transaction={transaction}
          onClose={() => {
            setShowAcceptIncomingTxModal(false);
            refreshTxListCb();
          }}
        />
      )}
      {showCancelOutgoingTxModal && (
        <CancelOutgoingTxModal
          transaction={transaction}
          onClose={() => {
            setShowCancelOutgoingTxModal(false);
            refreshTxListCb();
          }}
        />
      )}
      {showApproveOutgoingTxModal && (
        <ApproveOutgoingTxModal
          transaction={transaction}
          onClose={() => {
            setShowApproveOutgoingTxModal(false);
            refreshTxListCb();
          }}
        />
      )}
      {!hideActions && showTransactionDetailsModal && (
        <TransactionDetailsModal
          onBlockchainAddressConfirmed={async () => {
            refreshTxListCb();
          }}
          onClickOpenApprove={() => {
            setShowApproveOutgoingTxModal(true);
            handleDetailsClose();
          }}
          onClickOpenCancel={() => {
            setShowCancelOutgoingTxModal(true);
            handleDetailsClose();
          }}
          onClickOpenAccept={() => {
            setShowAcceptIncomingTxModal(true);
            handleDetailsClose();
          }}
          onClickOpenDecline={() => {
            setShowDeclineIncomingTxModal(true);
            handleDetailsClose();
          }}
        />
      )}
      <Table.TD style={{ position: "relative" }}>
        {(isOutgoing || isInternal) && (
          <CellEntity style={{ paddingRight: "0.2rem" }} title={originatorDid} className="localize-ignore">
            {transaction.originatorRef || transaction.originatorDisplay}
          </CellEntity>
        )}
        {isIncoming && (
          <CellEntity style={{ paddingRight: "0.2rem" }} title={beneficiaryDid} className="localize-ignore">
            {transaction.beneficiaryRef || transaction.beneficiaryDisplay}
          </CellEntity>
        )}
        {counterVASPDid && isOutgoing && <ArrowOutRow />}
        {counterVASPDid && isIncoming && <ArrowInRow />}
        {counterVASPDid && isInternal && <ArrowInBothRow />}
      </Table.TD>
      <Table.TD>
        {counterVASPDid ? (
          <CellEntityContainer style={{ paddingRight: "0.2rem" }}>
            {logo && <CellEntityAvatar src={logo} />}
            <CellEntityTitle title={counterVASPDid} className="localize-ignore">
              {counterVaspSimpleInfoData?.name || counterVASPDid}
            </CellEntityTitle>
          </CellEntityContainer>
        ) : (
          <Table.Cell>
            <Text {...TEXT_SIZE} align="centered" className="localize-ignore">
              {isOutgoing && <ArrowOutLong />}
              {isIncoming && <ArrowInLong />}
              {isInternal && <ArrowInBoth />}
            </Text>
          </Table.Cell>
        )}
      </Table.TD>
      <Table.TD>
        {(isOutgoing || isInternal) && (
          <CellEntity style={{ paddingRight: "0.2rem" }} title={beneficiaryDid} className="localize-ignore">
            {transaction.beneficiaryDisplay}
          </CellEntity>
        )}
        {isIncoming && (
          <CellEntity style={{ paddingRight: "0.2rem" }} title={originatorDid} className="localize-ignore">
            {transaction.originatorDisplay}
          </CellEntity>
        )}
      </Table.TD>
      <TableTDClickable>
        <Table.Cell>
          <Text {...TEXT_SIZE} weight="normal" className="localize-ignore">
            {TRANSACTION_TYPES[transaction.type]}
          </Text>
        </Table.Cell>
      </TableTDClickable>
      <TableTDClickable>
        <Table.Cell title={`${transaction.transactionAmount} atomic units`} className="localize-ignore">
          <Text {...TEXT_SIZE} align="right" className="localize-ignore">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <AssetText>{transaction.transactionAmountWithDecimals}</AssetText>
              {fiatAmount && <FiatText>{fiatAmount?.amountInLocalCurrency}</FiatText>}
            </div>
          </Text>
        </Table.Cell>
      </TableTDClickable>
      <TableTDClickable>
        <Table.Cell>
          <Text {...TEXT_SIZE} transform="uppercase" className="localize-ignore">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <AssetText>{transaction.transactionAsset}</AssetText>
              {fiatAmount && <FiatText>{fiatAmount?.currency}</FiatText>}
            </div>
          </Text>
        </Table.Cell>
      </TableTDClickable>
      <TableTDClickable>
        <Table.Cell
          as="time"
          dateTime={formattedCreatedAtDate}
          title={formattedCreatedAtDate}
          style={{ whiteSpace: "nowrap" }}
          className="localize-ignore"
        >
          <Text {...TEXT_SIZE} weight="normal" className="localize-ignore">
            {formattedDate} <br />
            at {formattedTime}
          </Text>
        </Table.Cell>
      </TableTDClickable>
      <TableTDClickable>
        <TransactionRowCellStatus
          style={{ width: "160px" }}
          transaction={transaction}
          hasRequestTrackingForMissingDataSetting={requestTrackingForMissingData}
        />
      </TableTDClickable>
      <TableTDColored
        color={color}
        aria-label={transaction.status}
        style={{ position: "sticky", right: 0, background: hideActions ? undefined : "white" }}
      >
        <Table.Cell>
          <Grid.Columns valign="centered" multiline={false} align="right" gapless>
            {!hideActions && showEditButton && (
              <Grid.Column narrow>
                <Link href={`/dashboard/transactions/${transaction.id}/edit`} passHref>
                  <ButtonLink
                    title="Edit transaction"
                    data-testid="transactionEditButton"
                    style={{ padding: "0 0.5rem" }}
                    disabled={$loading}
                  >
                    <SVGEdit data-testid="edit-icon" />
                  </ButtonLink>
                </Link>
              </Grid.Column>
            )}

            {!hideActions && showDetailsInfoButton && (
              <Grid.Column narrow>
                <ButtonLink
                  title="Show Details"
                  data-testid="transactionDetailsButton"
                  data-intercom-target="transaction-info-button-tourid-447932"
                  style={{ padding: "0 0.5rem" }}
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _addDetailsQueryParam(transaction!.id);
                  }}
                  disabled={$loading}
                >
                  <SVGInfo data-testid="info-icon" />
                </ButtonLink>
              </Grid.Column>
            )}

            {!hideActions && showOriginatorApproveCancelButtons && (
              <>
                <ApproveCancelButton
                  showApproveButton={transaction.isNew}
                  showCancelButton={true}
                  onClickOpenApprove={() => setShowApproveOutgoingTxModal(true)}
                  onClickOpenCancel={() => setShowCancelOutgoingTxModal(true)}
                  disabled={$loading}
                />
              </>
            )}

            {!hideActions && showBeneficiaryAcceptDeclineButtons && (
              <>
                <BeneficiaryAcceptDeclineButton
                  showAcceptButton={!transaction.isIncomplete}
                  onClickOpenAccept={() => setShowAcceptIncomingTxModal(true)}
                  onClickOpenDecline={() => setShowDeclineIncomingTxModal(true)}
                  disabled={$loading}
                  isAddressConfirmationNeeded={transaction.status === TransactionStatus.SENT}
                />
              </>
            )}
          </Grid.Columns>
        </Table.Cell>
      </TableTDColored>
    </Table.TR>
  );
}
